<div class="row mt-2 text-center">
  <div class="col-12">
    <h1>404 <small>- Seite nicht gefunden</small></h1>
  </div>
</div>
